module.exports = {"211421100":"绥中镇","211421101":"西甸子镇","211421102":"宽邦镇","211421103":"大王庙镇","211421104":"万家镇","211421105":"前所镇","211421106":"高岭镇","211421107":"前卫镇","211421108":"荒地镇","211421109":"塔山屯镇","211421113":"高台镇","211421114":"王宝镇","211421115":"沙河镇","211421116":"小庄子镇","211421201":"西平坡满族乡","211421202":"葛家满族乡","211421204":"高甸子满族乡","211421206":"范家满族乡","211421207":"明水满族乡","211421208":"秋子沟乡","211421210":"加碑岩乡","211421211":"永安堡乡","211421212":"李家堡乡","211421214":"网户满族乡","211421217":"城郊乡","211421400":"大台山果树农场","211421401":"前所果树农场","211421402":"绥中飞地经济区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211421.json
// module id = 688
// module chunks = 0